import {
  SlInput,
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import Select from "react-select";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import { toLakhs } from "../../utils/constants";
import * as XLSX from "xlsx";

function ClinetWiseRevenueMonth() {
  const [brandName, setBrandName] = useState("");
  const [data, setData] = useState([]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [salesPersons, setSalesPersons] = useState([]);
  const [salesPerson, setSalesPerson] = useState();
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('all');
  const [previewData, setPreviewData] = useState([]);
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/monthly/client-wise-revenue-month",
        method: "POST",
        responseType: "json",
        data: {
          brandName,
          newspaper: selectedNewspaper,
          salesPerson: salesPerson.value,
          month: selectedMonth,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        setPreviewData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    try {
      setDownloadLoader(true);
      const headers = [
        ["S.No", "Client", "Category", "Sales Person", "W2N Insertions", "W2N Revenue", `${selectedNewspaper} Insertions`, `${selectedNewspaper} Revenue`]
      ];
    
      // Data Rows
      const rows = previewData.map((item, index) => [
        index + 1,
        item.brand_name,
        item.category,
        item.sales_person,
        item.way2news?.insertions || 0,
        item.way2news?.revenue || 0,
        item.newspaper?.insertions || 0,
        item.newspaper?.revenue || 0,
      ]);
      rows.push("","","",'Totals',totals['w2n_insertions'], totals['w2n_revenue'], totals['paper_insertions'], totals['paper_revenue']);
      // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Client wise Revenue");
      XLSX.writeFile(workbook, `ClientwiseRevenue.xlsx`);

    } catch (error) {
      console.error(error);
    }
    finally{
      setDownloadLoader(false);
    }
  };
  const fetchCategries = async()=>{
    try {
      let res = await API({
        url: "/plansummary/categories",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setCategories(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  }
  const fetchSales = async () => {
    try {
      let res = await API({
        url: "monthly/sales-person",
        method: "POST",
        responseType: "json",
      });
      if (res.code === 200) {
        setSalesPersons(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    let value = e.target.value.replace(/_/g, ' ');
    if(value === 'all'){
      setPreviewData(data);
      return
    }
    let previewdata = data.filter((item) => item.category === value);
    setPreviewData(previewdata);
  };

  useEffect(() => {
    setSalesPerson(salesPersons[0]);
  }, [salesPersons]);
  useEffect(() => {
    fetchNewspapers();
    fetchCategries();
    fetchSales();
  }, []);

  const handleMonthChange = (date) => {
    setCategory("all");
    setSelectedMonth(date);
  };

  useEffect(() => {
    if (salesPerson) fetchData();
  }, [brandName, selectedNewspaper, salesPerson, selectedMonth]);

  let totals = {
    w2n_insertions: 0,
    w2n_revenue: 0,
    paper_insertions: 0,
    paper_revenue: 0
  };
  previewData.forEach((item) => {
    totals['w2n_insertions'] += item.way2news?.insertions || 0;
    totals['w2n_revenue'] += item.way2news?.revenue || 0;
    totals['paper_insertions'] += item.newspaper?.insertions || 0;
    totals['paper_revenue'] += item.newspaper?.revenue || 0;
  });
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Clinet Wise Revenue</h5>
        <aside className="flex gap-3 items-center">
          <SlInput
            type="text"
            placeholder="Search"
            label="Search"
            value={brandName}
            size="small"
            onSlInput={(e) => {setCategory('all');setBrandName(e.target.value)}}
          />
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => {setSelectedNewspaper(e.target.value);setCategory('all')}}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <SlSelect label="Category" size="small" value={category} onSlChange={handleCategoryChange}>
            <SlOption value="all">All</SlOption>
            {categories.map((category) => (
              <SlOption value={category.category_name.replace(/ /g, '_')}>{category.category_name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border h-5 rounded-md"
            />
          </div>
          <div>
            <label className="form-label">Sales Person</label>
            <Select
              className="min-w-[200px]"
              value={salesPerson}
              options={salesPersons}
              onChange={(e) => {setSalesPerson(e);setCategory('all')}}
            ></Select>
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered mt-2">
          <thead>
            <tr>
              <th rowSpan={2}>S.No</th>
              <th rowSpan={2}>Client</th>
              <th rowSpan={2}>Category</th>
              <th rowSpan={2}>Sales Person</th>
              <th colSpan={2}>W2N Data for the month</th>
              <th colSpan={2}>{selectedNewspaper} Data for the month</th>
            </tr>
            <tr>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>Insertions</th>
              <th>Revenue</th>
            </tr>
          </thead>
          {!loader && previewData?.length > 0 ? (
            <tbody>
              {previewData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.brand_name}</td>
                  <td>{item.category}</td>
                  <td>{item.sales_person}</td>
                  <td>{item.way2news?.insertions}</td>
                  <td>{toLakhs(item.way2news?.revenue || 0)}</td>
                  <td>{item.newspaper?.insertions}</td>
                  <td>{toLakhs(item.newspaper?.revenue)}</td>
                </tr>
              ))}
             
              <tr>
                <td colSpan={4}>Totals</td>
                <td>{totals['w2n_insertions']}</td>
                <td>{toLakhs(totals['w2n_revenue'])}</td>
                <td>{totals['paper_insertions']}</td>
                <td>{toLakhs(totals['paper_revenue'])}</td>
              </tr>
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={8} />
          ) : (
            <NoDataFound colspan={8} />
          )}
        </table>
      </ScrollContainer>
    </>
  );
}
export default ClinetWiseRevenueMonth;
